import { BattleFieldRole, Rank, UnitType } from "@/model/Enums";
import FormField, { FormFieldType } from "./FormField";
import TableHeader, { DefaultActionsHeader } from "./TableHeader";

export const CrusadeCardTableHeaders: TableHeader[] = [
  { text: "Unit Name", value: "name", sortable: true },
  {
    text: "Power Rating",
    value: "powerRating",
    sortable: true,
  },
  { text: "Crusade Points", value: "crusadePoints", sortable: true },
  DefaultActionsHeader,
];

export const CrusadeCardFormFields: FormField[] = [
  {
    label: "Unit Name",
    valueField: "name",
    type: FormFieldType.TEXT,
    required: true,
  },
  {
    label: "Battlefield Role",
    valueField: "battleFieldRole",
    type: FormFieldType.SELECT,
    options: Object.entries(BattleFieldRole).map((tuple) => {
      return { text: tuple[0], value: tuple[1] };
    }),
    required: true,
  },
  {
    label: "Power Rating",
    valueField: "powerRating",
    type: FormFieldType.NUMBER,
    required: true,
  },
  {
    label: "Crusade Points",
    valueField: "crusadePoints",
    type: FormFieldType.NUMBER,
    required: true,
  },
  {
    label: "Experience",
    valueField: "experience",
    type: FormFieldType.NUMBER,
    required: true,
  },
  {
    label: "Rank",
    valueField: "rank",
    type: FormFieldType.SELECT,
    options: Object.entries(Rank).map((tuple) => {
      return { text: tuple[0], value: tuple[1] };
    }),
    required: true,
  },
  {
    label: "Keywords",
    valueField: "keywords",
    type: FormFieldType.TAGS,
    options: [],
  },
  {
    label: "Unit Type",
    valueField: "unitType",
    type: FormFieldType.COMBO,
    options: Object.entries(UnitType).map((tuple) => {
      return { text: tuple[0], value: tuple[1] };
    }),
    required: true,
  },
  {
    label: "Equipment",
    valueField: "equipment",
    type: FormFieldType.TEXT,
    required: true,
  },
  {
    label: "Psychic Powers",
    valueField: "psychicPowers",
    type: FormFieldType.TAGS,
  },
  {
    label: "Warlord Traits",
    valueField: "warlordTraits",
    type: FormFieldType.TAGS,
  },
  {
    label: "Relics",
    valueField: "relics",
    type: FormFieldType.TAGS,
  },
  {
    label: "Other Upgrades and Abilities",
    valueField: "otherUpgrades",
    type: FormFieldType.TEXTAREA,
  },
];
